import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';
import createIconBuilderFromCondUiKit from './condUiKitAdapter';


// cond-ui-kit icon data (from @conductor/cond-ui-kit/lib/components/icons/ProductIcon/IcoMoonData/content.json)
const contentIconData = {
	icon: {
		attrs: [{}, {}, {}, {}, {}],
		grid: 0,
		isMulticolor: false,
		isMulticolor2: false,
		paths: [
			'M703.954 4c17.762 0 34.851 6.615 47.952 18.484l2.563 2.438 146.344 146.5c11.862 13.104 18.467 30.181 18.469 47.938v8.25c0.078 1.074 0.155 2.155 0.155 3.25 0 1.090-0.078 2.166-0.155 3.235v271.046c0 24.301-19.699 44-44 44-24.298-0.003-44-19.702-44-44v-230.282h-111.25c-39.458 0-71.422-31.998-71.422-71.437v-111.422h-460.61v826.298l280.437 0.218c22.187 2.254 39.501 21 39.501 43.782-0.003 22.778-17.315 41.512-39.501 43.765l-4.499 0.235h-292.515c-39.453-0.002-71.422-31.995-71.422-71.438v-859.437c0.004-39.437 31.971-71.421 71.422-71.422h532.531zM736.61 186.859h55.328l-55.328-55.344v55.344z',
			'M760.64 623.219c11.72 0 21.107 7.029 23.454 18.749 18.755 98.48 44.538 124.29 143 143.048 11.72 2.346 18.765 11.73 18.765 23.453-0.005 11.718-7.048 21.093-18.765 23.437-98.464 18.76-124.245 44.563-143 143.048-2.349 9.376-11.734 18.749-23.454 18.749-11.717 0-21.090-7.032-23.437-18.749-18.755-98.485-44.552-124.288-143.016-143.048-11.715-2.344-18.746-11.718-18.75-23.437 0-11.723 9.374-21.107 18.75-23.453 98.464-18.758 124.261-44.566 143.016-143.048 2.347-11.718 11.72-18.747 23.437-18.749z',
			'M468.531 552.656c22.189 2.251 39.498 21 39.501 43.781-0.002 22.782-17.312 41.515-39.501 43.766l-4.499 0.234h-137.11c-24.299 0-43.998-19.701-44-44 0.002-24.298 19.701-44 44-44h137.11l4.499 0.219z',
			'M697.062 369.797c22.187 2.251 39.498 21 39.501 43.781-0.002 22.782-17.314 41.514-39.501 43.766l-4.499 0.234h-365.642c-24.299 0-43.998-19.699-44-44 0.002-24.298 19.701-44 44-44l370.141 0.219z',
			'M514.25 186.954c22.182 2.256 39.499 20.987 39.501 43.765 0 22.779-17.317 41.509-39.501 43.766l-4.499 0.234h-182.829c-24.301 0-44-19.699-44-44 0.002-24.298 19.701-44 44-44h182.829l4.499 0.235z',
		],
		tags: ['content'],
	},
	attrs: [{}, {}, {}, {}, {}],
	properties: {
		code: 59766,
		id: 1,
		name: 'content',
		order: 3433,
		prevSize: 20,
	},
	setIdx: 0,
	setId: 2,
	iconIdx: 13,
};

// Create IconBuilder from cond-ui-kit data
const ContentIconBuilder: IconBuilder = createIconBuilderFromCondUiKit(
	contentIconData as any,
	'#89c32e', // Default green color for new navigation
);

export default ContentIconBuilder;
